export default "<p>\r\n  paymethod works!</p>\r\n  <div class=\"card-container\"></div>\r\n"